import { render, staticRenderFns } from "./TelegramAuth.vue?vue&type=template&id=4a5b5e48&"
import script from "./TelegramAuth.vue?vue&type=script&lang=ts&"
export * from "./TelegramAuth.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports